import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import { PluginProvider } from './context/PluginContext.jsx'
import { AuthProvider } from './context/AuthContext.jsx'
import { MarketProvider } from './context/MarketContext.jsx'
import { resolveStorefrontImageUrl } from './api/client.js'
import './luxury-refresh.css'
import './rtl.css'

// Guarantee resolveStorefrontImageUrl is globally accessible to prevent crashes across all chunks
if (typeof window !== 'undefined') {
    window.resolveStorefrontImageUrl = resolveStorefrontImageUrl;
}
if (typeof globalThis !== 'undefined') {
    globalThis.resolveStorefrontImageUrl = resolveStorefrontImageUrl;
}

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: '40px', background: 'darkred', color: 'white', minHeight: '100vh', fontFamily: 'monospace' }}>
                    <h1>Application Crashed!</h1>
                    <p>Please take a screenshot of this error and send it to the developer:</p>
                    <pre style={{ background: 'black', padding: '20px', overflowX: 'auto', borderRadius: '5px' }}>
                        {this.state.error?.toString()}
                        <br/><br/>
                        {this.state.error?.stack}
                    </pre>
                </div>
            );
        }
        return this.props.children;
    }
}

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <ErrorBoundary>
            <BrowserRouter>
                <AuthProvider>
                    <PluginProvider>
                        <MarketProvider>
                            <App />
                        </MarketProvider>
                    </PluginProvider>
                </AuthProvider>
            </BrowserRouter>
        </ErrorBoundary>
    </React.StrictMode>,
)

// Clean up and unregister PWA Service Workers to prevent layout caching deadlock
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (let registration of registrations) {
      registration.unregister();
    }
  });
}
if ('caches' in window) {
  caches.keys().then(names => {
    for (let name of names) {
      caches.delete(name);
    }
  });
}
